import script from "./PerformLogout.vue?vue&type=script&lang=js"
export * from "./PerformLogout.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__